<script setup>
defineProps(['label', 'hex'])
defineOptions({ inheritAttrs: false })
</script>

<template>
	<div class="font-primary w-fit rounded-lg border bg-[#fff] px-4 pt-3 pb-2 text-[10px] leading-none uppercase sm:border-2 sm:text-xs" :style="{ borderColor: hex }">
		{{ label }}
	</div>
</template>
